export const isIntegrationGroup = (group: EmployeeGroup) =>
  Boolean(group.integrationId || group.intersectingIntegrationId);
